import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
  } from '@angular/core';
  import { SelectItem } from 'src/app/modules/shared/components/custom-select/select-item';
import { BookingStatus } from 'src/app/modules/shows/enums/booking-status.enum';
  
  @Component({
    selector: 'app-booking-status-select',
    templateUrl: './booking-status-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
  export class BookingStatusSelectComponent implements OnChanges {
    typeSelect: string = 'Reservas: '
    @Input() active?: string;
    @Output() activeChange = new EventEmitter<string | undefined>();
  
    selected?: SelectItem<BookingStatus | undefined>;
    status: SelectItem<BookingStatus | undefined>[] = [
      {
        label: `Todas`,
        value: undefined
      },
      {
        label: 'Confirmadas',
        value: BookingStatus.BOOKED_SUCCESSFULLY
      },
      {
        label: 'Canceladas',
        value: BookingStatus.CANCELED
      }
    ] ;
  
    constructor() {}
  
    ngOnChanges(changes: SimpleChanges): void {
      if (changes.active) {
        this.selected = this.status?.find(
          (select) => select.value === this.active
        );
      }
    }
  
    change(selectedItem: SelectItem<BookingStatus | undefined>): void {
      this.active = selectedItem.value;
      this.selected = selectedItem;
      this.activeChange.emit(this.active);
    }
  }
  